export default __webpack_public_path__ + "static/media/azure-service-bus.58fb8332.svg";